//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByTeam = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [error, setError] = useState()

	let selectedTeam

	console.log('inside SearchByTeam')
	//
	//
	//
	//
	//
	//Call backend to get all the current TEAMS for our dropdown
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.currentTeamsArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [setLoadedTeams])

	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}
	//
	//
	//

	//console.log('loadedTeams: ' + JSON.stringify(loadedTeams))

	let navigate = useNavigate()
	//For handling a search by team request:
	const handleChange1 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = teamArray[selectedValue]
		//console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		navigate(`/league/teamSchedule/${teamId}`)
	}

	return (
		<React.Fragment>
			{/* <Card> */}
			<div style={{ marginBottom: '2rem', overflowX: 'hidden' }}>
				{/* <div className='row'>
					<div className='LTVinstructions'>Search by Team: </div>
				</div> */}
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							{/* <form className='form-control-lg'> */}
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									// className='my-1 mr-sm-2 scheduleselector'
									onChange={handleChange1}
								>
									<option defaultValue>Search by Team...</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{/* {team.toUpperCase()} */}
											{team.divisionName + ' >>> ' + team.teamName}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default SearchByTeam
